<!--
 * @Author: cmchiu
 * @Date: 2022-04-25 18:01:58
 * @LastEditTime: 2024-02-20 16:06:36
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\components\Banner\banner.vue
 * 
-->
<template>
    <div class="banner">
        <slick ref="slick" :options="configs" class="slider main-slider slick_wrap" v-if="bannerLs.length">
            <div class="slick-slide" v-for="item in bannerLs" :key="item.ADID">
                <a
                    :href="item.ADURL.replace('postnews.aspx', 'postnews')"
                    :key="item.ADID"
                    :target="item.target === '10' ? '_self' : item.target === '20' ? '_blank' : '_top'"
                    :rel="item.target === '20' ? 'noreferrer noopener' : ''"
                    :title="`${item.TitleC}${item.target === '20' ? '（另開視窗）' : ''}`"
                    tabindex="0"
                >
                    <img :src="item.imgsrc" :alt="item.TitleC" width="366" height="92" />
                </a>
            </div>
        </slick>
    </div>
</template>

<script>
import Slick from 'vue-slick'
import XEUtils from 'xe-utils'
import { getBannerList } from '@/api/campus'

export default {
    name: 'banner',

    components: { Slick },

    props: {
        dot: {
            type: Boolean,
            default: false,
        },

        infinite: {
            type: Boolean,
            default: true,
        },

        speed: {
            type: Number,
            default: 500,
        },

        slidesToShow: {
            type: Number,
            default: 4,
        },

        slidesToScroll: {
            type: Number,
            default: 1,
        },

        autoplay: {
            type: Boolean,
            default: true,
        },

        autoplaySpeed: {
            type: Number,
            default: 3000,
        },

        vertical: {
            type: Boolean,
            default: true,
        },

        verticalSwiping: {
            type: Boolean,
            default: true,
        },

        arrows: {
            type: Boolean,
            default: true,
        },
    },

    data: function () {
        return {
            configs: {
                dot: this.dot,
                infinite: this.infinite,
                speed: this.speed,
                slidesToShow: this.slidesToShow,
                slidesToScroll: this.slidesToScroll,
                autoplay: this.autoplay,
                autoplaySpeed: this.autoplaySpeed,
                vertical: this.vertical,
                verticalSwiping: this.verticalSwiping,
                // swipe: true,
                // swipeToSlide: true,
                // touchMove: true,
                arrows: this.arrows,
            },
            bannerLs: [],
        }
    },

    created: function () {
        this.getBannerList()
    },

    methods: {
        async getBannerList() {
            let params = {
                widgetnum: 30,
            }
            await getBannerList(params).then(res => {
                if (res.Code === 1) {
                    this.bannerLs = XEUtils.orderBy(res.Items, 'CreateDate')
                    // this.$message({
                    //     message: res.Msg,
                    //     type: 'success',
                    // })
                }
            })
        },

        next() {
            this.$refs.slick.next()
        },

        prev() {
            this.$refs.slick.prev()
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slick.reSlick()
            })
        },
    },
}
</script>

<style scoped lang="scss">
.slick-slide {
    a {
        display: unset;
    }
}
</style>
